import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ReactComponent as InfoIcon } from '../_images/info-circle.svg';
import PopupOneButton from "./PopupOneButton";

function PopupInfo({ show, text, onHide, onConfirm }) {
    function getIcon() {
        return <InfoIcon fill="blue" width={48} height={48} />;
    }

    return (
        <PopupOneButton show={show} text={text} onHide={onHide} onConfirm={onConfirm} icon={getIcon()} />
    )
}

export default PopupInfo
